declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string | number | boolean>) => void;
    };
    dataLayer?: unknown[];
  }
}

export function initGTM(): void {
  const containerId = process.env.REACT_APP_GTM_CONTAINER_ID;
  if (!containerId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);
}

export function track(event: string, data?: Record<string, string | number | boolean>): void {
  window.umami?.track(event, data);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}
